const INTERNATIONAL_PHONE_NUMBER_REGEX = /^(\+?[0-9]){1,4}\d{6,14}$/;

const COUNTRY_PHONE_NUMBER_REGEX_PAIRS = {
  'am-AM': /^(\+?374)\d{6,14}$/,
  'ar-AE': /^(\+?971)\d{6,14}$/,
  'ar-BH': /^(\+?973)\d{6,14}$/,
  'ar-DZ': /^(\+?213)\d{6,14}$/,
  'ar-EG': /^(\+?20)\d{6,14}$/,
  'ar-IQ': /^(\+?964)\d{6,14}$/,
  'ar-JO': /^(\+?962)\d{6,14}$/,
  'ar-KW': /^(\+?965)\d{6,14}$/,
  'ar-SA': /^(\+?966)\d{6,14}$/,
  'ar-SY': /^(\+?963)\d{6,14}$/,
  'ar-TN': /^(\+?216)\d{6,14}$/,
  'be-BY': /^(\+?375)\d{6,14}$/,
  'bg-BG': /^(\+?359)\d{6,14}$/,
  'bn-BD': /^(\+?880)\d{6,14}$/,
  'cs-CZ': /^(\+?420)\d{6,14}$/,
  'da-DK': /^(\+?45)\d{6,14}$/,
  'de-DE': /^(\+?49)\d{10,11}$/,
  'de-AT': /^(\+?43)\d{10,11}$/,
  'de-CH': /^(\+?41)\d{9}$/,
  'el-GR': /^(\+?30)\d{6,14}$/,
  'en-AU': /^(\+?61)\d{6,14}$/,
  'en-GB': /^(\+?44)\d{6,14}$/,
  'en-GG': /^(\+?44)\d{6,14}$/,
  'en-GH': /^(\+?233)\d{6,14}$/,
  'en-HK': /^(\+?852)\d{6,14}$/,
  'en-MO': /^(\+?853)\d{6,14}$/,
  'en-IE': /^(\+?353)\d{6,14}$/,
  'en-IN': /^(\+?91)\d{6,14}$/,
  'en-KE': /^(\+?254)\d{6,14}$/,
  'en-MT': /^(\+?356)\d{6,14}$/,
  'en-MU': /^(\+?230)\d{6,14}$/,
  'en-NG': /^(\+?234)\d{6,14}$/,
  'en-NZ': /^(\+?64)\d{6,14}$/,
  'en-PK': /^(\+?92)\d{6,14}$/,
  'en-RW': /^(\+?250)\d{6,14}$/,
  'en-SG': /^(\+?65)\d{6,14}$/,
  'en-SL': /^(\+?94)\d{6,14}$/,
  'en-TZ': /^(\+?255)\d{6,14}$/,
  'en-UG': /^(\+?256)\d{6,14}$/,
  'en-US': /^(\+?1)\d{6,14}$/,
  'en-ZA': /^(\+?27)\d{6,14}$/,
  'en-ZM': /^(\+?26)\d{6,14}$/,
  'es-CL': /^(\+?56)\d{6,14}$/,
  'es-EC': /^(\+?593)\d{6,14}$/,
  'es-ES': /^(\+?34)\d{9}$/,
  'es-MX': /^(\+?52)\d{6,14}$/,
  'es-PA': /^(\+?507)\d{6,14}$/,
  'es-PY': /^(\+?595)\d{6,14}$/,
  'es-UY': /^(\+?598)\d{6,14}$/,
  'et-EE': /^(\+?372)\d{6,14}$/,
  'fa-IR': /^(\+?98)\d{6,14}$/,
  'fi-FI': /^(\+?358)\d{6,14}$/,
  'fj-FJ': /^(\+?679)\d{6,14}$/,
  'fo-FO': /^(\+?298)\d{6,14}$/,
  'fr-FR': /^(\+?33)\d{9}$/,
  'fr-GF': /^(\+?594)\d{6,14}$/,
  'fr-GP': /^(\+?590)\d{6,14}$/,
  'fr-MQ': /^(\+?596)\d{6,14}$/,
  'fr-RE': /^(\+?262)\d{6,14}$/,
  'he-IL': /^(\+?972)\d{6,14}$/,
  'hu-HU': /^(\+?36)\d{6,14}$/,
  'id-ID': /^(\+?62)\d{6,14}$/,
  'it-IT': /^(\+?39)\d{10}$/,
  'ja-JP': /^(\+?81)\d{6,14}$/,
  'kk-KZ': /^(\+?7|8)\d{6,14}$/,
  'kl-GL': /^(\+?299)\d{6,14}$/,
  'ko-KR': /^(\+?82)\d{6,14}$/,
  'lt-LT': /^(\+?370)\d{6,14}$/,
  'ms-MY': /^(\+?6)\d{6,14}$/,
  'nb-NO': /^(\+?47)\d{6,14}$/,
  'ne-NP': /^(\+?977)\d{6,14}$/,
  'nl-BE': /^(\+?32)\d{6,14}$/,
  'nl-NL': /^(\+?31)\d{9}$/,
  'pl-PL': /^(\+?48)\d{9}$/,
  'pt-BR':
    /(?=^(\+?5{2}-?|0)[1-9]{2}-?\d{4}-?\d{4}$)(^(\+?5{2}-?|0)[1-9]{2}-?[6-9]{1}\d{3}-?\d{4}$)|(^(\+?5{2}-?|0)[1-9]{2}-?9[6-9]{1}\d{3}-?\d{4}$)/,
  'pt-PT': /^(\+?351)\d{6,14}$/,
  'ro-RO': /^(\+?4)\d{6,14}$/,
  'ru-RU': /^(\+?7|8)?9\d{9}$/,
  'sl-SI': /^(\+?386)\d{6,14}$/,
  'sk-SK': /^(\+?421)\d{6,14}$/,
  'sr-RS': /^(\+?3816)\d{6,14}$/,
  'sv-SE': /^(\+?46)\d{7,10}$/,
  'th-TH': /^(\+?66)\d{6,14}$/,
  'tr-TR': /^(\+?90)\d{6,14}$/,
  'uk-UA': /^(\+?38)\d{6,14}$/,
  'vi-VN': /^(\+?84)\d{6,14}$/,
  'zh-CN': /^(\+?86)\d{6,14}$/,
  'zh-TW': /^(\+?886)\d{6,14}$/,
};

// get country key that match one of countries regex keys
const getCountryKeyFromPhoneInputCountryObject = country => {
  if (!country?.countryCode) return null;

  return Object.keys(COUNTRY_PHONE_NUMBER_REGEX_PAIRS).find(
    countryKey => countryKey.split('-')[1].toLocaleLowerCase() === country.countryCode,
  );
};

export const getPhoneNumberRegex = country => {
  const countryKey = getCountryKeyFromPhoneInputCountryObject(country);
  return countryKey ? COUNTRY_PHONE_NUMBER_REGEX_PAIRS[countryKey] : INTERNATIONAL_PHONE_NUMBER_REGEX;
};

export const phoneNumberValidation = (value, country) => {
  if (!value || value.length === 0) return true;
  if (!country || Object.keys(country).length === 0) return false;

  // check if a number starts with selected country dial code
  if (country.dialCode && value.length >= 2) {
    let valueWithoutPlus = value;
    valueWithoutPlus = valueWithoutPlus.replace('+', '');
    if (!valueWithoutPlus.startsWith(country.dialCode)) return false;
  }

  const isPhoneNumberValid = getPhoneNumberRegex(country).test(value);

  return isPhoneNumberValid;
};
